export default __webpack_public_path__ + "static/media/LandingWithoutHeader.9a84c033.svg";